const REPLAY_TIME_PRECISION = 3;

const round = (value, precision = REPLAY_TIME_PRECISION) => {
  const factor = 10 ** precision;
  return Math.round(Number(value || 0) * factor) / factor;
};

export const createCatRunningReplayFrame = (world) => ({
  t: round(world.elapsedMs / 1000),
  y: round(world.player.y),
  s: 0,
  a: Number.isFinite(world.player.frameIndex) ? world.player.frameIndex : 0,
});

export const createCatRunningReplay = ({ frames, distanceM, elapsedMs }) => ({
  frames: Array.isArray(frames) ? frames.map((frame) => ({ ...frame })) : [],
  dur: round(elapsedMs / 1000),
  synthetic: false,
  targetDistanceM: Math.max(0, Math.floor(Number(distanceM) || 0)),
});

export const createCatRunningPlayEndRequest = ({ roundToken, result, replay }) => ({
  roundToken,
  distanceM: Math.max(0, Math.floor(Number(result?.distanceM) || 0)),
  churuCount: Math.max(0, Math.floor(Number(result?.churuCount) || 0)),
  elapsedMs: Math.max(0, Math.round(Number(result?.elapsedMs) || 0)),
  replayJson: JSON.stringify(replay),
});

export const getCatRunningFrameReplayOptions = (replay) => {
  const frames = Array.isArray(replay?.frames) ? replay.frames : null;
  if (!frames?.length) return null;

  return {
    frameReplay: frames.map((frame) => ({
      ...frame,
      t: Number(frame?.t) || 0,
      y: Number(frame?.y) || 0,
    })),
    frameReplayDurationSec: Number(replay?.dur) || frames[frames.length - 1].t,
  };
};
